import React from "react";
import TitleName from "./TitleName";
import "./CommonCeramic.css";

const CeramicCard = ({ title, des, imgUrl }) => {
  return (
    <div
      className="card p-3 w-100"
      style={{
        boxShadow:
          "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
        border: "none",
        height: "430px",
      }}
    >
      <div className="ceramic-card">
        <img src={imgUrl} alt={title} className="w-100" />
        <div className="card-content">
          <h4 className="fw-bold mt-2">{title}</h4>
          <p className="mt-3">{des}</p>
        </div>
      </div>
    </div>
  );
};

const CeramicCoatingOptions = () => {
  return (
    <div className="container">
      <TitleName title="OUR CERAMIC" subtitle="Coating Process" />
      <div className="row">
        <div className="col-md-4 mt-3">
          <CeramicCard
            imgUrl="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTrICdLbDOG8r8ettqKI22aOFFAb2K1lwlaz8_rHzt0ZxVvLWFudEpycIf6bxh3ztyNyXM&usqp=CAU"
            title="Detailed Surface Preparation"
            des="We begin by thoroughly cleaning and decontaminating your car’s exterior to ensure a pristine surface. Any existing imperfections are corrected to provide a smooth base for the coating."
          />
        </div>
        <div className="col-md-4 mt-3">
          <CeramicCard
            imgUrl="https://img.freepik.com/free-photo/beautiful-car-polishing-service_23-2149212247.jpg"
            title="Application of Ceramic Coating"
            des="Our skilled technicians apply the ceramic coating in multiple layers, ensuring even coverage and optimal bonding with the paint. The coating is allowed to cure fully to achieve maximum durability."
          />
        </div>
        <div className="col-md-4 mt-3">
          <CeramicCard
            imgUrl="https://www.shutterstock.com/image-photo/car-service-worker-applying-nano-600nw-1814908295.jpg"
            title="Final Inspection"
            des="After the coating has cured, we conduct a thorough inspection to ensure a flawless finish. We make any necessary adjustments to ensure your car looks its best."
          />
        </div>
      </div>
    </div>
  );
};

export default CeramicCoatingOptions;
